/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Management_Head_TitleInputs */

const en_wb_management_head_title = /** @type {(inputs: Wb_Management_Head_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weekly operations brief`)
};

const lv_wb_management_head_title = /** @type {(inputs: Wb_Management_Head_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nedēļas darba kopsavilkums`)
};

/**
* | output |
* | --- |
* | "Weekly operations brief" |
*
* @param {Wb_Management_Head_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_management_head_title = /** @type {((inputs?: Wb_Management_Head_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Management_Head_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_management_head_title(inputs)
	return en_wb_management_head_title(inputs)
});